import React from 'react'
import { NodeViewWrapper, NodeViewContent } from '@tiptap/react'
import { Shield, Lock, StickyNote } from 'lucide-react'
import { cn } from '@/lib/utils'

type Props = {
  selected: boolean
}

export function InternalNoteNodeView({ selected }: Props) {
  return (
    <NodeViewWrapper
      className={cn(
        'group relative my-4 rounded-md border border-amber-300/60 bg-amber-50 px-4 py-3 dark:border-status-orange/30 dark:bg-amber-900/20',
        selected && 'ProseMirror-selectednode',
      )}
      data-type='InternalNote'
    >
      <div className='mb-2 flex items-center gap-2 text-amber-700 dark:text-amber-300' contentEditable={false}>
        <StickyNote className='h-4 w-4' />
        <span className='text-xs font-semibold tracking-wide uppercase'>Internal Note</span>
        <span className='ml-2 text-[11px] text-amber-800/80 dark:text-amber-200/80'>(not included in published docs)</span>
      </div>
      <div className='prose prose-sm max-w-none text-amber-900 dark:text-amber-100'>
        <NodeViewContent />
      </div>
    </NodeViewWrapper>
  )}

export default InternalNoteNodeView
